<template>
  <div class="container-fluid springter-section">
    <lang-menu></lang-menu>
    <div class="row">
      <div class="col-12">
        <logo type="white" @click.native="$ksvuefp.$emit('ksvuefp-nav-click', {nextIndex: 0})"></logo>
      </div>
    </div>
    <div class="section-content">
      <div class="row">
        <div class="col-12">
          <h2>{{ $t('section8Title') }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <a class="button" role="button" title="Springter Brochure" v-bind:href="brochureUrl">{{ $t('section8ButtonDownload') }}</a>
        </div>
      </div>
      <div class="row boxes">
        <div class="col-lg-3 col-md-3 col-sm-6">
          <span class="section-icon">
            <img src="../assets/img/command-line.svg" alt="Webr" />
          </span>
          <p class="strong">{{ $t('section8Box1') }}</p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <span class="section-icon">
            <img src="../assets/img/mobile-programming.svg" alt="Mobile" />
          </span>
          <p class="strong">{{ $t('section8Box2') }}</p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <span class="section-icon">
            <img src="../assets/img/api.svg" alt="API" />
          </span>
          <p class="strong">{{ $t('section8Box3Title') }}</p>
          <!-- <p>{{ $t('section8Box3') }}</p> -->
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
          <span class="section-icon">
            <img src="../assets/img/list.svg" alt="Information" />
          </span>
          <p class="strong">{{ $t('section8Box4Title') }}</p>
          <!-- <p>{{ $t('section8Box4') }}</p> -->
        </div>
      </div>
    </div>
    <div class="footer row">
      <div class="col-md-12">
        <a href="mailto:hello@springter.com" title="hello@springter.com">hello@springter.com</a>
        <div class="springter-section__sublogo hidden-xs-down">
          <span>{{ $t('section8Footer') }}</span><img src="../assets/img/Forward_Manual_v3-23.svg" alt="Logo Springter" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Logo from './shared/Logo';
import LangMenu from './shared/LangMenu';

export default {
  name: 'springter-section-8',
  components: {
    Logo,
    LangMenu,
  },
  computed: {
    brochureUrl() {
      return this.$i18n.t('brochureUrl');
    },
  },
};
</script>

<style lang="scss" scoped>
  .springter-section{
    text-align: center;

    @include mq('phablet', 'max') {
        text-align: left;

        .button{
          margin: 0;
          display: inherit;
        }
    }

    @include mq('phablet', 'max') {
        .boxes{
          margin-top: 10px;
          text-align: center;
        }
    }

    @include mqlandscape(){
        text-align: left;

        .button{
          margin-left: 15px;
        }
    }

    &__sublogo{
      position: absolute;
      top: calc(100% - 130px);
      width: 70%;
      right: 50px;
      height: 70px;
      text-align: right;
      
      span{
        vertical-align: bottom;
        padding-right: 7px;
      }

      img{
        width: 200px;
        min-width: 200px;
      }

      @include mqlandscape(){
        display: none;
      }
    }
  }

  h2{
    width: 70%;
    margin: 35px auto 30px;
    text-transform: initial;

    @include mq('desktop', 'max') {
        font-size: $h--medium;
        margin-bottom: 15px;
        margin-top: 10px;
    }

    @include mq('tablet-wide', 'max') {
        font-size: $h--small;
        margin-bottom: 15px;
    }

    @include mq('phablet', 'max') {
        font-size: $h--xxx-small;
        margin-bottom: 15px;
        text-transform: initial;
        margin-top: 20px;
        width: 100%;
    }

    @include mqlandscape(){
        font-size: $h--xxx-small;
        margin-bottom: 15px;
        text-transform: initial;
        margin-top: 20px;
        width: 100%;
    }
  }

  p{
    width: 68%;
    margin: 0 auto;

    &.strong{
      font-family: $stack--big-letters;
      margin-bottom: 2px;
      margin-top: 10px;
    }

    @include mq('phablet', 'max') {
        width: 100%;
    }
    @include mqlandscape(){
        width: 100%;
    }
  }

  .footer{
      position: absolute;
      top: calc(100% - 60px);
      width: 100%;
      background-color: $c--white;
      text-align: center;
      height: 60px;
      padding-top: 18px;

      a{
        color: $c--black;
        text-decoration: none;
        font-family: $stack--heading;
        font-weight: 700;

        &:hover{
          text-decoration: underline;
        }
      }
  }

  .section-icon{
    width: 60%;
    display: block;
    margin: 0 auto;
    height: 100px;

    img{
      height: 100%;
    }

    @include mq('desktop', 'max') {
        height: 80px;
    }

    @include mq('tablet-wide', 'max') {
        height: 60px;
        margin-top: 25px;
    }

    @include mq('phablet', 'max') {
        height: 45px;
        margin-top: 15px;
    }
    @include mqlandscape(){
        height: 45px;
        margin-top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/SpringterSection8.vue